import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import { CALENDAR_GA_EVENT_ACTION, CALENDAR_GA_EVENT_LABEL } from 'constants/analytics'
import ModalContext from 'contexts/ModalContext'
import { OfferPageActions, takeCurrentOfferState } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import UserAnalyticsActionContext from 'contexts/userAnalyticsActionContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import React, { useCallback, useContext, useEffect, useRef } from 'react'
import OfferCalendarRoomModal from './OfferCalendarRoomModal'
import OfferCalendarRoomOptions from './OfferCalendarRoomOptions'
import FilterChip from 'LuxKit/Chips/FilterChip'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'

interface Props {
  open: boolean;
  room?: App.PackageRoomType;
  variant?: 'dropdown' | 'modal';
}

function OfferCalendarRoomLineSelect(props: Props) {
  const { open, variant = 'dropdown', room } = props
  const triggerRef = useRef<HTMLButtonElement | null>(null)

  const onUserAnalyticsAction = useContext(UserAnalyticsActionContext)
  const dispatch = useOfferPageDispatch()
  const showModal = useContext(ModalContext)

  const onToggleOpen = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'room' })
    if (open) {
      onUserAnalyticsAction(CALENDAR_GA_EVENT_ACTION.CloseSubFilter, CALENDAR_GA_EVENT_LABEL.OpenRoom)
    } else {
      onUserAnalyticsAction(CALENDAR_GA_EVENT_ACTION.OpenSubFilter, CALENDAR_GA_EVENT_LABEL.OpenRoom)
    }
  }, [dispatch, onUserAnalyticsAction, open])

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeSubFilter })
    onUserAnalyticsAction(CALENDAR_GA_EVENT_ACTION.CloseSubFilter, CALENDAR_GA_EVENT_LABEL.OpenRoom)
  }, [dispatch, onUserAnalyticsAction])

  useEffect(() => {
    if (open && variant === 'modal') {
      showModal(<OfferCalendarRoomModal />).then(() => {
        onClose()
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <>
      <FilterChip
        size="medium"
        onClick={onToggleOpen}
        endIcon={variant === 'dropdown' ? <DropdownChevron open={open} /> : undefined}
      >
        {room?.name ?? 'All rooms'}
      </FilterChip>
      {variant === 'dropdown' && <DropdownList
        size="S"
        title="Rooms"
        open={open}
        anchorRef={triggerRef}
        triggerRef={triggerRef}
        hasDismissButton
        onClose={onClose}
      >
        <OfferCalendarRoomOptions onSelect={onClose} />
      </DropdownList>}
    </>
  )
}

export default withOfferPageState((currentState) => {
  const state = takeCurrentOfferState(currentState)

  return {
    open: state.activeSubFilter === 'room',
    room: state.room,
  }
}, OfferCalendarRoomLineSelect)
